import { render, staticRenderFns } from "./CheckpointLevelDropdownCell.vue?vue&type=template&id=480f2278&scoped=true"
import script from "./CheckpointLevelDropdownCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointLevelDropdownCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointLevelDropdownCell.vue?vue&type=style&index=0&id=480f2278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f2278",
  null
  
)

export default component.exports